module.exports = __webpack_public_path__ + "static/media/img_brand02.2983ee5d.png";